import React from 'react';
import './Membership.css';

const MEMBER_FORM_URL = 'https://ebta.outseta.com/forms/Rm8rwx94';
const ASSOCIATED_FORM_URL = 'https://ebta.outseta.com/forms/BWzAAg9E';

const Membership = () => {
  return (
    <div className="membership-page">
      <div className="container">
        <h1 className="page-title">Membership</h1>
        <p className="page-subtitle">
          Join the European Brief Therapy Association and connect with professionals worldwide
          who are passionate about the Solution Focused approach.
        </p>

        <div className="membership-content">
          <div className="membership-info">
            <h2>Become a member of EBTA!</h2>
            <p className="membership-welcome">
              EBTA welcomes <strong>individuals and organisations</strong> who are in good professional
              standing* in their country of origin, who have basic exposure to Solution Focused training
              and accept the purpose, goals and rules of EBTA.
            </p>
            <p className="membership-standing">
              *'Good professional standing' means that you have a professional training related to helping,
              teaching or research professions. This requirement is read broadly.
            </p>
            <h3 className="membership-types-title">There are two types of membership in EBTA</h3>
          </div>

          <div className="membership-plans">
            <div className="membership-plan">
              <h3 className="plan-title">Individual Membership</h3>
              <p className="plan-description">
                For individuals who want to connect, contribute and grow together with the Solution Focused
                community in Europe and worldwide.
              </p>

              <h4 className="plan-subtitle">Membership offers</h4>
              <ul className="benefits-list">
                <li>Collaboration with like-minded professionals and critical friends</li>
                <li>Opportunities to join task groups and develop Solution Focused ideas and practices and EBTA's work</li>
                <li>Support in spreading Solution Focused ideas within EBTA and your own networks</li>
                <li>A voice in EBTA through voting rights</li>
                <li>Discounts at EBTA Conferences</li>
              </ul>

              <h4 className="plan-subtitle">How to join</h4>
              <p className="plan-description">
                You need at least <strong>20 hours of Solution Focused training or equivalent</strong>.
                Complete the registration form below. Your application is approved by the EBTA Board and
                membership becomes active after payment.
              </p>

              <p className="plan-fee">Annual fee: €55,00</p>

              <a
                href={MEMBER_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="plan-button"
              >
                Become a member
              </a>
            </div>

            <div className="membership-plan membership-plan-secondary">
              <h3 className="plan-title">Associated Membership</h3>
              <p className="plan-description">
                For associations and organisations that promote or facilitate Solution Focused practice and
                want to connect and collaborate with EBTA.
              </p>

              <h4 className="plan-subtitle">Membership offers</h4>
              <ul className="benefits-list">
                <li>Formal connection and collaboration with the Solution Focused community in Europe and worldwide</li>
                <li>A voice in EBTA through voting rights</li>
                <li>Opportunities to contribute to and support Solution Focused ideas and practice across Europe</li>
                <li>Use of the official EBTA logo together with the wording <strong>"Associated Member of EBTA"</strong></li>
              </ul>

              <h4 className="plan-subtitle">How to join</h4>
              <p className="plan-description">
                Your organisation must be formally registered in a European country. Complete the registration
                form below. Membership is approved by the EBTA Board and formalised through a mutual agreement.
              </p>

              <p className="plan-fee">Annual fee: minimum €200,00</p>
              <p className="plan-fee-note">
                A higher contribution from organisations representing more than 100 members is appreciated.
              </p>

              <a
                href={ASSOCIATED_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="plan-button plan-button-secondary"
              >
                Become an associated member
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Membership;
